export default __webpack_public_path__ + "static/media/Helm of Baleful Blood.d85889da.jpg";